import helperServices from '../../services/helperServices'

export default class {
  constructor (model) {
    this.id = model.id
    this.name = model.name
    this.minAge = model.minAge
    this.maxAge = model.maxAge
    this.isFree = model.isFree
    this.openingDate = model.openingDate
    this.inputOpeningDate = helperServices.getDateForInput(this.openingDate)
    this.closingDate = model.closingDate
    this.inputClosingDate = helperServices.getDateForInput(this.closingDate)
  }

  // retourne si un item est valide
  get isValid () {
    return (this.minAge !== null && this.minAge !== '') || (this.maxAge !== null && this.maxAge !== '')
  }
}
